// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#focus--j5MFS:focus {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: var(--bo-ui-focus-outline-offset, 2px);
  border-radius: 0.25rem;
}
@supports selector(:focus-visible) {
  #focus--j5MFS:focus {
    outline: none;
    outline-offset: 0;
    border-radius: 0.25rem;
  }
  #focus--j5MFS:focus-visible {
    outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
    outline-offset: var(--bo-ui-focus-outline-offset, 2px);
    border-radius: 0.25rem;
  }
}
#focus-within--saYja:focus-within {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: 0px;
  border-radius: 0.25rem;
}
.playlistHeaderContainer--OGABm {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 2px solid #CBD5E0;
  padding-bottom: 1.5rem;
}
.playlistHeaderContainer--OGABm .playlistBadges--Eo4rh {
  display: flex;
  flex-direction: row;
}
.playlistHeaderContainer--OGABm .playlistBadge--g_zaB {
  padding: 0.125rem 0 0.5rem;
  color: #495A7C;
  display: flex;
  align-items: center;
}
.playlistHeaderContainer--OGABm .playlistBadge--g_zaB::before {
  content: '•';
  color: #001550;
  font-size: 1.5rem;
  padding-right: 4px;
  padding-left: 4px;
  line-height: 1.5rem;
}
.playlistHeaderContainer--OGABm .playlistBadge--g_zaB:first-child::before {
  content: none;
}
.playlistHeaderContainer--OGABm .playlistButtons--nPbKa {
  display: flex;
  flex-direction: row;
}
.playlistHeaderContainer--OGABm .playlistButtons--nPbKa .playlistButton--ErGXR:first-child {
  margin-right: 0.5rem;
}
.playlistHeaderContainer--OGABm .playlistButtons--nPbKa .playlistButton--ErGXR {
  --bo-ui-button-outline-background-color-hover: transparent;
  --bo-ui-button-outline-svg-fill: transparent;
  --bo-ui-button-outline-svg-stroke: #00217D;
}
.playlistHeaderContainer--OGABm .playlistButtons--nPbKa .playlistButton--ErGXR button {
  width: auto;
  height: 48px;
  font-size: 1rem;
}
.playlistHeaderContainer--OGABm .playlistButtons--nPbKa .playlistButton--ErGXR .optionsButton--Eo2Xu {
  --bo-ui-button-svg-height: 6px;
  --bo-ui-button-svg-width: 24px;
}
.playlistHeaderContainer--OGABm .playlistButtons--nPbKa .playlistButton--ErGXR .optionsButton--Eo2Xu[data-state='open'] {
  --bo-ui-button-outline-text-colour: #001550;
  --bo-ui-button-outline-border: 2px solid #001550;
}
.playlistHeaderContainer--OGABm .playlistButtons--nPbKa .playlistButton--ErGXR .optionsButton--Eo2Xu svg {
  stroke: none;
}
.optionsDropdownWrapper--ihDNB {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  background: #FFF;
  border-radius: 4px;
  width: 230px;
  padding: 0.25rem;
}
.optionsDropdownWrapper--ihDNB .optionsItem--xB9Wl {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  color: #2D3748;
  padding: 0.5rem;
  margin: 0.25rem;
}
.optionsDropdownWrapper--ihDNB .optionsItem--xB9Wl:focus {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: var(--bo-ui-focus-outline-offset, 2px);
  border-radius: 0.25rem;
}
@supports selector(:focus-visible) {
  .optionsDropdownWrapper--ihDNB .optionsItem--xB9Wl:focus {
    outline: none;
    outline-offset: 0;
    border-radius: 0.25rem;
  }
  .optionsDropdownWrapper--ihDNB .optionsItem--xB9Wl:focus-visible {
    outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
    outline-offset: var(--bo-ui-focus-outline-offset, 2px);
    border-radius: 0.25rem;
  }
}
.optionsDropdownWrapper--ihDNB .optionsItem--xB9Wl svg {
  margin-right: 0.75rem;
}
.optionsDropdownWrapper--ihDNB .optionsItem--xB9Wl:hover {
  color: #00217D;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@boclips-ui/styles/src/focus.less","webpack://./src/components/playlists/playlistHeader/style.module.less"],"names":[],"mappings":"AAIE;EACE,sDAAA;EACA,sDAAA;EACA,sBAAA;ACHJ;ADUE;EACE;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;ECRJ;EDUE;IACE,sDAAA;IACA,sDAAA;IACA,sBAAA;ECRJ;AACF;ADaE;EACE,sDAAA;EACA,mBAAA;EACA,sBAAA;ACXJ;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gCAAA;EACA,sBAAA;AAoBF;AA1BA;EASI,aAAA;EACA,mBAAA;AAoBJ;AA9BA;EAcI,0BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAmBJ;AAjBI;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAmBN;AAhBI;EACE,aAAA;AAkBN;AA/CA;EAkCI,aAAA;EACA,mBAAA;AAgBJ;AAdI;EACE,oBAAA;AAgBN;AAtDA;EA0CM,0DAAA;EACA,4CAAA;EACA,0CAAA;AAeN;AA3DA;EA+CQ,WAAA;EACA,YAAA;EACA,eAAA;AAeR;AAhEA;EAqDQ,8BAAA;EACA,8BAAA;AAcR;AAZQ;EACE,2CAAA;EACA,gDAAA;AAcV;AAxEA;EA8DU,YAAA;AAaV;AANA;EACE,4CAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAQF;AAbA;EAQI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAQJ;AD1FE;EACE,sDAAA;EACA,sDAAA;EACA,sBAAA;AC4FJ;ADrFE;EACE;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;ECuFJ;EDrFE;IACE,sDAAA;IACA,sDAAA;IACA,sBAAA;ECuFJ;AACF;AAvCA;EAkBM,qBAAA;AAwBN;AArBI;EACE,cAAA;AAuBN","sourcesContent":["@import './vars';\n\n#focus {\n  // For any browser that doesn't focus-visible (Safari)\n  &:focus {\n    outline: @focus-outline;\n    outline-offset: @focus-outline-offset;\n    border-radius: .25rem;\n  }\n\n  // For browsers that do support focus-visible:\n  // - turn off focus styles\n  // - apply styles only to focus-visible\n  // https://www.tpgi.com/focus-visible-and-backwards-compatibility/\n  @supports selector(:focus-visible) {\n    &:focus {\n      outline: none;\n      outline-offset: 0;\n      border-radius: .25rem;\n    }\n    &:focus-visible {\n      outline: @focus-outline;\n      outline-offset: @focus-outline-offset;\n      border-radius: .25rem;\n    }\n  }\n}\n\n#focus-within{\n  &:focus-within {\n    outline: @focus-outline;\n    outline-offset: 0px;\n    border-radius: .25rem;\n  }\n}\n","@import '@boclips-ui/styles/src/colors';\n@import '@boclips-ui/styles/src/focus';\n\n.playlistHeaderContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  border-bottom: 2px solid @gray-400;\n  padding-bottom: 1.5rem;\n\n  .playlistBadges {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .playlistBadge {\n    padding: 0.125rem 0 0.5rem;\n    color: @gray-700;\n    display: flex;\n    align-items: center;\n\n    &::before {\n      content: '•';\n      color: @blue-900;\n      font-size: 1.5rem;\n      padding-right: 4px;\n      padding-left: 4px;\n      line-height: 1.5rem;\n    }\n\n    &:first-child::before {\n      content: none;\n    }\n  }\n\n  .playlistButtons {\n    display: flex;\n    flex-direction: row;\n\n    & .playlistButton:first-child {\n      margin-right: 0.5rem;\n    }\n\n    .playlistButton {\n      --bo-ui-button-outline-background-color-hover: transparent;\n      --bo-ui-button-outline-svg-fill: transparent;\n      --bo-ui-button-outline-svg-stroke: @blue-800;\n\n      button {\n        width: auto;\n        height: 48px;\n        font-size: 1rem;\n      }\n\n      .optionsButton {\n        --bo-ui-button-svg-height: 6px;\n        --bo-ui-button-svg-width: 24px;\n\n        &[data-state='open'] {\n          --bo-ui-button-outline-text-colour: @blue-900;\n          --bo-ui-button-outline-border: 2px solid @blue-900;\n        }\n\n        svg {\n          stroke: none;\n        }\n      }\n    }\n  }\n}\n\n.optionsDropdownWrapper {\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);\n  background: @white;\n  border-radius: 4px;\n  width: 230px;\n  padding: 0.25rem;\n\n  .optionsItem {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    cursor: pointer;\n    color: @gray-800;\n    padding: 0.5rem;\n    margin: 0.25rem;\n    #focus;\n\n    svg {\n      margin-right: 0.75rem;\n    }\n\n    &:hover {\n      color: @blue-800;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"focus": `focus--j5MFS`,
	"focus-within": `focus-within--saYja`,
	"playlistHeaderContainer": `playlistHeaderContainer--OGABm`,
	"playlistBadges": `playlistBadges--Eo4rh`,
	"playlistBadge": `playlistBadge--g_zaB`,
	"playlistButtons": `playlistButtons--nPbKa`,
	"playlistButton": `playlistButton--ErGXR`,
	"optionsButton": `optionsButton--Eo2Xu`,
	"optionsDropdownWrapper": `optionsDropdownWrapper--ihDNB`,
	"optionsItem": `optionsItem--xB9Wl`
};
export default ___CSS_LOADER_EXPORT___;
